export default function createRequestPayload(client, url, method = 'get', data, meta, headers, timeout) {
    return {
        request: {
            client,
            url,
            method,
            ...(data && { data }),
            ...(meta && { meta }),
            ...(headers && { headers }),
            ...(timeout && { timeout }),
        },
    };
}
